module.exports = __webpack_public_path__ + "prod/1.42.2/img/suning-icon.d39fb592.png";